import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { H3 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import { ROUTES } from 'static/menusConstants'
import { getCdnImg } from 'utils/getters'
import styles from './Related.module.scss'

const Related = ({ webpart: { relatedCollections }, collections }) => {
  const { push } = useRouter()

  const collectionsPublished = useMemo(
    () =>
      relatedCollections.reduce((acc, current) => {
        const { slug } = current
        // find published collection with the same slug
        const collection = collections?.find(
          ({ slug: collectionSlug, publishedStatus }) => collectionSlug === slug && publishedStatus === 'published'
        )
        // add it to total array
        if (collection) acc.push(collection)
        return acc
      }, []),
    [relatedCollections, collections]
  )

  return (
    collectionsPublished.length === 2 && (
      <section className={styles.Related}>
        <div className={styles.Block}>
          <H3 weight="bold" type="heading" className={styles.Title}>
            Related collections
          </H3>

          {collectionsPublished.length > 1 && (
            <div className={styles.Cards}>
              {collectionsPublished.slice(0, 2).map(({ slug, title, description, image, background }, index) => (
                <div
                  key={index}
                  className={`${styles.Card} ${index === 0 ? styles.LeftSide : styles.RightSide}`}
                  style={{ backgroundColor: background }}
                  onClick={() => push(`/${ROUTES.collections}/${slug}`)}
                  onKeyDown={() => push(`/${ROUTES.collections}/${slug}`)}
                  tabIndex="0"
                  role="button"
                >
                  <img alt={title} src={getCdnImg(image, 588)} className={styles.Img} />
                  <div className={styles.Title}>{title}</div>
                  <div className={styles.Description}>{description}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    )
  )
}

Related.propTypes = {
  webpart: PropTypes.shape({
    relatedCollections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        slug: PropTypes.string
      })
    )
  }),
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      slug: '',
      title: '',
      description: '',
      image: '',
      background: '',
      publishedStatus: ''
    })
  )
}

Related.defaultProps = {
  webpart: { relatedCollections: [] },
  collections: []
}

export default Related
